export default class Offertenav {
    constructor() {
        this.Offertenav();
    }
    Offertenav(){
        var button = document.getElementById('nav-menu');

        button.addEventListener('click', function(e){
            if (document.getElementById('dropdown-menu').contains(e.target)){

            }
            else{
                document.getElementById("dropdown-menu").classList.toggle("show");
            }
        })
        window.addEventListener('click', function(e){
            if (document.getElementById('nav-menu').contains(e.target)){

            } else{
                document.getElementById("dropdown-menu").classList.remove('show');
            }
          });

    }
}
